import { VISIT_PATH_OPTIONS } from '../../../constants/visitPath';

// 매출 필터를 컴포넌트가 아니라 "필드 정의 목록"으로 관리한다.
// 필드를 하나 추가한다 = 이 배열에 한 줄 추가. 탭 배분·요약칩·초기화가 자동으로 따라온다.
//
// 값은 필드마다 항상 배열이고, 빈 배열 = 전체(조건 없음).
// - multi:true  → 여러 개 선택 가능. 서버에 배열로 전송(qs 가 key[0], key[1] 로 직렬화).
// - multi:false → 하나만 선택. 같은 값을 다시 누르면 해제된다. 서버에 단일 값으로 전송.
// - type:'chip' → 칩 나열, type:'list' → 검색 가능한 드롭다운(옵션이 길거나 지점마다 달라지는 값).

// - type:'search' → 탭 밖(패널 상단) 검색창. 값은 [검색어] 하나짜리 배열.
//
// 탭은 결제 / 상품 / 담당·경로 3개(#168 A안). 상품구분·상품 선택이 들어오며 결제·상품 한 탭이 너무 길어졌다.
// 구독권 구분(결제완료/결제예정)은 결제 상태 성격이라 결제 탭에 둔다 — 두 탭 높이도 이걸로 맞춰진다.
export const FILTER_GROUPS = [
  { key: '결제', tabLabel: '결제' },
  { key: '상품', tabLabel: '상품' },
  { key: '담당 · 경로', tabLabel: '담당·경로' },
];

// 상품 구분 칩 값. 라커 = 상품 카테고리 유형 LOCKER(자리 배정 무관), 기간상품 = 운동복 등 PERIOD, 일반상품 = 재고형 STOCK.
// 일일권(TRIAL)은 화면에서만 쓰는 묶음 값이다 — 서버로는 일일권 구분에서 고른 TRIAL_TICKET/TRIAL_PASS 로 풀어 보낸다.
// 양수금은 상품이 아니라 하위 탭(양수금 내역)으로 본다(서버는 TRANSFER_FEE 를 계속 받는다).
const TRIAL_KIND = 'TRIAL';
export const PRODUCT_KIND_OPTIONS = [
  { value: 'TICKET', label: '수강권' },
  { value: 'PASS', label: '이용권' },
  { value: TRIAL_KIND, label: '일일권' },
  { value: 'LOCKER', label: '라커' },
  { value: 'PERIOD', label: '기간상품' },
  { value: 'STOCK', label: '일반상품' },
  { value: 'SUBSCRIPTION', label: '구독' },
];

export const TRIAL_KIND_OPTIONS = [
  { value: 'TRIAL_TICKET', label: '수강권 일일' },
  { value: 'TRIAL_PASS', label: '이용권 일일' },
];

// 상품 드롭다운 묶음. kinds = 서버 상품 kind(백엔드 selectSalesFilterProducts 와 같은 값).
// 일일권은 수강권 일일·이용권 일일을 한 묶음으로 둔다(상품 구분 칩과 같은 이름). 구독은 고를 상품이 없어 빠진다.
export const PRODUCT_SECTIONS = [
  { value: 'TICKET', label: '수강권', kinds: ['TICKET'] },
  { value: 'PASS', label: '이용권', kinds: ['PASS'] },
  { value: TRIAL_KIND, label: '일일권', kinds: TRIAL_KIND_OPTIONS.map(option => option.value) },
  { value: 'LOCKER', label: '라커', kinds: ['LOCKER'] },
  { value: 'PERIOD', label: '기간상품', kinds: ['PERIOD'] },
  { value: 'STOCK', label: '일반상품', kinds: ['STOCK'] },
];

// 상품 구분이 전체(미선택)거나 그 칩이 골라져 있을 때 하위 구분을 보인다. 전체에도 그 상품이 들어 있으므로.
const productKindIncludes = kind => filters => {
  const kinds = filters.productKind || [];
  return kinds.length === 0 || kinds.includes(kind);
};

export const SEARCH_FIELD_KEY = 'searchInput';

export const FILTER_FIELDS = [
  // 통합 검색(회원 이름·전화번호·상품명). 요약칩 맨 앞에 오도록 첫 필드로 둔다.
  {
    key: SEARCH_FIELD_KEY,
    label: '검색',
    group: null,
    type: 'search',
    multi: false,
    options: [],
  },
  {
    key: 'paymentStatus',
    label: '결제상태',
    group: '결제',
    type: 'chip',
    multi: false,
    // 대기(ORDER_CREATED)·취소(CANCELED)는 매출 집계에서 항상 제외되므로 옵션에 없다.
    options: [
      { value: 'PAID', label: '결제' },
      { value: 'REFUNDED', label: '환불' },
    ],
  },
  {
    key: 'paymentMethod',
    label: '결제수단',
    group: '결제',
    type: 'chip',
    multi: true,
    options: [
      { value: 'CARD', label: '카드' },
      { value: 'TRANSFER', label: '계좌이체' },
      { value: 'CASH', label: '현금' },
      // 분할결제(#49) — 여러 수단으로 나눠 수납한 주문. 카드/현금 칩에는 섞이지 않는다.
      { value: 'MIXED', label: '분할결제' },
    ],
  },
  {
    key: 'paymentProvider',
    label: '결제유형',
    group: '결제',
    type: 'chip',
    multi: false,
    options: [
      { value: 'OFFLINE', label: '현장결제' },
      { value: 'APP', label: '앱결제' },
    ],
  },
  {
    key: 'newType',
    label: '신규여부',
    group: '결제',
    type: 'chip',
    multi: false,
    options: [
      { value: 'NEW', label: '신규등록' },
      { value: 'RE', label: '재등록' },
    ],
  },
  {
    key: 'product',
    label: '상품 선택',
    // 탭 밖 — 패널 상단 검색창 바로 아래(검색과 같은 '찾기' 도구라 어느 탭에서든 보인다).
    group: null,
    type: 'list',
    multi: true,
    // 상품 탭 맨 위(사용자 요청). 조회 범위의 주문에 등장한 상품. 값은 "KIND:id"(종류마다 ID 공간이 달라서). 런타임에 주입된다.
    options: [],
    dynamicOptions: 'product',
  },
  {
    key: 'productKind',
    label: '상품 구분',
    group: '상품',
    type: 'chip',
    multi: true,
    // 캡션 없이 회원권 → 일반상품 → 기타 순서로만 둔다. 캡션을 달면 상품 탭이 결제 탭보다 두 배 길어졌다.
    options: PRODUCT_KIND_OPTIONS,
    // 평소엔 전체 + 앞 4개만, 마지막 칩 바로 옆 화살표로 펼치기/접기(사용자 요청).
    // 접혀 있어도 고른 칩은 보인다(숨은 조건이 생기지 않게).
    collapsedCount: 4,
  },
  {
    key: 'ticketType',
    label: '수강권 구분',
    group: '상품',
    type: 'chip',
    multi: true,
    // 상품 구분이 전체이거나 수강권을 골랐을 때 보인다(숨으면 값도 비운다 — normalizeFilters).
    // 수강권 안에서만 거른다 — 다른 상품은 그대로 둔다(2026-10-12 사용자 결정).
    visibleWhen: productKindIncludes('TICKET'),
    options: [
      { value: 'PRIVATE', label: '개인레슨' },
      { value: 'GROUP', label: '그룹레슨' },
      { value: 'DUET', label: '듀엣레슨' },
      { value: 'OT', label: 'OT' },
    ],
  },
  {
    key: 'trialKind',
    label: '일일권 구분',
    group: '상품',
    type: 'chip',
    multi: true,
    visibleWhen: productKindIncludes(TRIAL_KIND),
    // 일일권 안에서만 거른다. 상품 구분 '전체'에서도 걸리도록 서버에 trialKind 로 따로 보낸다
    // (상품 구분에 일일권이 있으면 productKind 쪽도 이 값으로 풀린다 — expandProductKinds).
    options: TRIAL_KIND_OPTIONS,
  },
  {
    key: 'subscriptionType',
    label: '구독권 구분',
    group: '결제',
    type: 'chip',
    multi: false,
    options: [
      { value: 'PAID', label: '결제완료' },
      { value: 'SCHEDULED', label: '결제예정' },
    ],
  },
  {
    key: 'visitPath',
    label: '방문경로',
    group: '담당 · 경로',
    type: 'list',
    multi: true,
    options: VISIT_PATH_OPTIONS,
    // 16개를 한 줄로 늘어놓으면 뭐가 뭔지 안 읽힌다. 경로 성격으로 묶어 헤더에 아이콘을 단다.
    // 아이콘을 값마다 하나씩 달지 않는 이유 — 16개 서로 다른 아이콘은 시각적 소음이다.
    optionGroups: [
      {
        key: 'online',
        label: '온라인',
        values: ['NAVER_BLOG', 'INSTAGRAM', 'HOMEPAGE', 'WEB_SEARCH', 'COMMUNITY', 'DAANGN'],
      },
      { key: 'message', label: '발송 · 알림', values: ['KAKAO_CHANNEL', 'ALIMTALK', 'PUSH', 'SMS'] },
      { key: 'offline', label: '오프라인 광고', values: ['SIGNBOARD', 'BANNER', 'FLYER', 'AD_MATERIAL'] },
      { key: 'referral', label: '소개', values: ['STAFF_REFERRAL', 'FRIEND_REFERRAL'] },
      // 기타는 직접 입력 글과 무관하게 한 묶음으로 거른다(#177).
      { key: 'other', label: '기타', values: ['OTHER'] },
    ],
  },
  {
    key: 'saleManager',
    label: '판매 담당자',
    group: '담당 · 경로',
    type: 'list',
    multi: true,
    // 지점마다 달라지므로 옵션은 런타임에 주입된다(getBranchManager).
    options: [],
    dynamicOptions: 'saleManager',
  },
];

export const INITIAL_FILTERS = FILTER_FIELDS.reduce((acc, field) => {
  acc[field.key] = [];
  return acc;
}, {});

export const isFieldVisible = (field, filters) => !field.visibleWhen || field.visibleWhen(filters);

/** 상품 선택 값("KIND:id")의 종류가 지금 상품 구분·일일권 구분 범위 안인지. 범위가 없으면(전체) 모두 허용. */
export const isProductKindAllowed = (kind, filters) => {
  const kinds = expandProductKinds(filters);
  const trialKinds = filters.trialKind || [];
  return (
    (kinds.length === 0 || kinds.includes(kind)) &&
    (!kind.startsWith('TRIAL_') || trialKinds.length === 0 || trialKinds.includes(kind))
  );
};

/**
 * 숨은 필드(상위 칩이 풀린 수강권·일일권 구분)는 값을 비운다. 숨은 조건이 몰래 걸려 있지 않게.
 * 상품 선택도 상품 구분 범위 밖의 상품은 뺀다 — 남겨 두면 서버가 교집합을 써서 결과가 조용히 0건이 된다.
 */
export const normalizeFilters = filters => {
  const visibleOnly = FILTER_FIELDS.reduce(
    (acc, field) => (isFieldVisible(field, acc) || (acc[field.key] || []).length === 0 ? acc : { ...acc, [field.key]: [] }),
    filters,
  );
  const products = visibleOnly.product || [];
  const allowedProducts = products.filter(value => isProductKindAllowed(String(value).split(':')[0], visibleOnly));
  return allowedProducts.length === products.length ? visibleOnly : { ...visibleOnly, product: allowedProducts };
};

/** 상품 구분의 일일권을 일일권 구분 값으로 푼다. 일일권 구분을 안 고르면 둘 다. */
export const expandProductKinds = filters =>
  (filters.productKind || []).flatMap(kind => {
    if (kind !== TRIAL_KIND) {
      return [kind];
    }
    const trialKinds = filters.trialKind || [];
    return trialKinds.length > 0 ? trialKinds : TRIAL_KIND_OPTIONS.map(option => option.value);
  });

/** 값 토글. 단일선택은 같은 값을 다시 누르면 해제, 다중선택은 있으면 빼고 없으면 더한다. */
export const toggleFilterValue = (filters, field, value) => {
  const current = filters[field.key] || [];
  let next;
  if (!field.multi) {
    next = current[0] === value ? [] : [value];
  } else {
    next = current.includes(value) ? current.filter(v => v !== value) : [...current, value];
  }
  return normalizeFilters({ ...filters, [field.key]: next });
};

export const clearFilterField = (filters, fieldKey) => normalizeFilters({ ...filters, [fieldKey]: [] });

/** 선택된 값들을 라벨로 요약한다. 3개 이상이면 "A, B +N". */
export const summarizeValues = (field, values, options) => {
  if (!values || values.length === 0) {
    return '전체';
  }
  if (field.type === 'search') {
    return values[0];
  }
  const source = options || field.options;
  const labels = values.map(v => source.find(o => o.value === v)?.label ?? v);
  if (labels.length <= 2) {
    return labels.join(', ');
  }
  return `${labels[0]}, ${labels[1]} +${labels.length - 2}`;
};

/** 조건이 걸린 필드 수. 탭 뱃지에 쓴다. */
export const countActiveFields = (filters, fields) =>
  fields.filter(field => isFieldVisible(field, filters) && (filters[field.key] || []).length > 0).length;

/** 요약 줄에 깔 조건칩. 적용본 기준. */
export const buildFilterTokens = (applied, optionOverrides = {}) =>
  FILTER_FIELDS.filter(field => isFieldVisible(field, applied) && (applied[field.key] || []).length > 0).map(field => ({
    key: field.key,
    label: field.label,
    value: summarizeValues(field, applied[field.key], optionOverrides[field.key]),
  }));

/**
 * 필터 상태를 서버 쿼리 파라미터로 바꾼다.
 * 다중선택은 배열 그대로 넘겨 qs 가 key[0], key[1] 로 직렬화하게 두고,
 * 단일선택은 기존 파라미터 이름·형태를 유지한다(빈 값은 null = 전체).
 */
export const buildFilterQuery = filters =>
  FILTER_FIELDS.reduce((acc, field) => {
    const values = !isFieldVisible(field, filters)
      ? []
      : field.key === 'productKind'
      ? expandProductKinds(filters)
      : filters[field.key] || [];
    acc[field.key] = field.multi ? values : (values[0] ?? null);
    return acc;
  }, {});
